import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Article from "@/pages/Article";
import Category from "@/pages/Category";
import Author from "@/pages/Author";
import Search from "@/pages/Search";
import Videos from "@/pages/Videos";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AdminEditor from "@/pages/AdminEditor";
import AdminAbout from "@/pages/AdminAbout";
import Subscribe from "@/pages/Subscribe";
import SubscribeSuccess from "@/pages/SubscribeSuccess";
import "@/App.css";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/author/:id" element={<Author />} />
              <Route path="/search" element={<Search />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/subscribe/success" element={<SubscribeSuccess />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/new" element={<AdminEditor />} />
              <Route path="/admin/edit/:slug" element={<AdminEditor />} />
              <Route path="/admin/about" element={<AdminAbout />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
